// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
    production: false,
    firebase: {
      apiKey: "AIzaSyAk4UhK0L1ZYa_hAoYHnfRc_ZSCB8Qdc-g",
  authDomain: "zeroarmario.firebaseapp.com",
  projectId: "zeroarmario",
  storageBucket: "zeroarmario.appspot.com",
  messagingSenderId: "4761305316",
  appId: "1:4761305316:web:5406184500f785ef656cf1",
  measurementId: "G-65FPDLKWJ6"
    }
};



/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
